import ApiGet from "../../../../api-controller-mod/api-serv/get-api/getApi";
import ApiGetRealtime from "../../../../api-controller-mod/api-serv/get-api/getApiRealtime";
import { API_ENDPOINTS } from "../../../../context-controller-mod/context-serv/global-provider/api-shell/api-provider";

export type NotificationMessage = {
  module?:  string;
  message?: string;
};

export type NotificationApiItem = {
  id:          number;
  uuid:        string;
  requesterId: string;
  approverId:  string;
  message:     string | NotificationMessage;  // ← allow object from SSE
  status:      string;
  readStatus:  string;
  createdAt:   string;
  decisionAt:  string;
};
export type NotificationPagination = {
  page:       number;
  size:       number;
  totalPages: number;
  totalItems: number;
};

export type NotificationApiResponse = {
  success:   boolean;
  requestId: string;
  data:
    | NotificationApiItem[]
    | {
        items:        NotificationApiItem[];
        pagination?:  NotificationPagination;
      };
};

export const getNotificationRoute = (module: string): string | null => {
  switch (module.trim().toLowerCase()) {
    case 'workflow': return '/workflow';
    case 'content':  return '/content';
    case 'career':   return '/career';
    case 'setting':  return '/setting';
    case 'inbox':    return '/inbox';
    case 'media':    return '/media';
    default:         return null;
  }
};

export const getAllNotification = (page: number, size: number) =>
  ApiGet<NotificationApiResponse>(
    `${API_ENDPOINTS.GET_ALL_NOTIFICATIONS}?page=${page}&size=${size}`
  );

export const readNotification = (uuid: string) =>
  ApiGet<NotificationApiResponse>(
    `${API_ENDPOINTS.READ_NOTIFICATION}?uuid=${uuid}`
  );

/* ── SSE ─────────────────────────────────────────────────── */

export const subscribeNotificationSSE = (
  onMessage: (item: NotificationApiItem) => void,
  onError?:  (e: unknown) => void,
): () => void =>
  ApiGetRealtime(
    API_ENDPOINTS.REAL_TIME_NOTIFICATION,
    'notification',
    (data) => onMessage(data as NotificationApiItem),
    onError,
  );